export default {
    PROJECTS: 'projects'
}
